import { Divider, CardTitle } from '@vnetwork/ui/primitives';
import { SectionShell } from '../section-shell';
import { CustomConfigSection } from './custom-config-section';
import { SlaConfigSection } from './sla-config-section';
import { NdaConfigSection } from './nda-config-section';

/**
 * Contract settings, consolidated into ONE card. Currency/supplier linkage, the
 * SLA, and the NDA were three separate cards but serve the same purpose —
 * optional contract configuration — so they read better grouped, separated by
 * quiet dividers. The SLA/NDA sub-blocks carry their own switch-gated headers;
 * the currency block gets a plain sub-title.
 */

export function SettingsSection({ customerId }: { customerId: number }) {
  return (
    <SectionShell
      title="Settings"
      description="Currency, supplier linkage, and the agreements attached to this contract."
    >
      <div style={{ display: 'grid', gap: 'var(--vn-space-3)' }}>
        <CardTitle>Currency &amp; supplier</CardTitle>
        <CustomConfigSection customerId={customerId} />
      </div>

      <Divider />
      <SlaConfigSection />

      <Divider />
      <NdaConfigSection />
    </SectionShell>
  );
}
